import dayjs from 'dayjs';

import { formatInAppTz } from '@/lib/date';

/** The hyphen every Reports tab renders for a genuinely absent value — a Customer with no email, a
 *  non-Delivered order's delivery date, a Component's subscription status, a never-active Device's
 *  Last active on.
 *
 *  NOT for a never-active Device's three metrics: Total active time, Avg runtime/day and Total
 *  alerts each render `0`. The zeros and the hyphen are not interchangeable (AC 112362, CONTEXT.md
 *  "Last active on"), so nothing here maps a falsy number to a hyphen. */
export const EMPTY_CELL = '-';

/** "DD MMM YYYY | HH:MM AM/PM" — Order Date & time, Last active on. The UTC wire instant on the
 *  application (Eastern) clock (ADO 120986), matching the shipped Orders/Payments/Requests stamp. */
export function formatReportDateTime(iso: string | null | undefined): string {
  return iso ? formatInAppTz(iso, 'D MMM YYYY | hh:mm A') : EMPTY_CELL;
}

/** "DD MMM YYYY" — Delivery date, Warranty valid till, Purchase date. These arrive as Eastern
 *  `YYYY-MM-DD` calendar dates, so they are formatted without conversion (ADR-0007). */
export function formatReportDate(iso: string | null | undefined): string {
  return iso ? dayjs(iso).format('D MMM YYYY') : EMPTY_CELL;
}
